<ion-content>
  <img class="bg-overlay" src="/assets/icon/ink_cloud.jpg" />
  <div class="login-wrap" [ngClass]="{'mobile-bg': platform === 'mobile', 'veeam': this.theme === 'veeam'}">

    <div class="big-logo">
      <div *ngIf="isPageReady" class="bg desktop-only">
        <img *ngIf="this.theme !== 'veeam'" src="assets/icon/welcome-journey-logo.svg">
        <img *ngIf="this.theme === 'veeam'" src="assets/theme/veeam/veeam-logo-2025-smaller.svg">
      </div>

      <img *ngIf="isPageReady && this.theme !== 'veeam'" class="logo-mobile mobile-only" src="assets/icon/journey-logo-mobile.svg">
      <img *ngIf="isPageReady && this.theme === 'veeam'" class="logo-mobile mobile-only" src="assets/theme/veeam/veeam-logo-2025.svg">
    </div>

    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate *ngIf="isPageReady">
      <div class="height-shrinked">
        <div *ngIf="isPageReady" class="bg desktop-only">
          <img *ngIf="this.theme !== 'veeam'" src="assets/icon/welcome-journey-logo.svg">
          <img *ngIf="this.theme === 'veeam'" src="assets/theme/veeam/veeam-logo-2025.svg">
        </div>

        <img *ngIf="isPageReady && this.theme !== 'veeam'" class="logo-mobile mobile-only" src="assets/icon/journey-logo-mobile.svg">
        <img *ngIf="isPageReady && this.theme === 'veeam'" class="logo-mobile mobile-only" src="assets/theme/veeam/veeam-logo-2025.svg">
      </div>

      <div class="form-container">
        <div class="input-box" [ngClass]="{error: isSubmitted && loginForm.controls['login'].invalid}"
             autofocus="true">
          <ion-label class="desktop-only" position="stacked">{{"__LOGIN_LOGIN_LABEL__" | translate}}</ion-label>
          <ion-input placeholder="{{'__LOGIN_LOGIN__' | translate}}"
                     [@headShake]="loginForm.controls['login'].invalid && animationState"
                     [autocomplete]="'username'" formControlName="login" class="my-input"></ion-input>
          <div class="error-text">{{"__LOGIN_FIELD_REQ__" | translate}}</div>
        </div>

        <div class="input-box" [ngClass]="{error: isSubmitted && loginForm.controls['password'].invalid}">
          <ion-label class="desktop-only" position="stacked">{{"__LOGIN_PASSWORD_LABEL__" | translate}}</ion-label>
          <ion-input placeholder="{{'__LOGIN_PASSWORD__' | translate}}" type="password"
                     [@headShake]="loginForm.controls['password'].invalid && animationState"
                     [autocomplete]="'current-password'" formControlName="password" [@enterListRight]
                     class="my-input"></ion-input>
          <div class="error-text">{{"__LOGIN_FIELD_REQ__" | translate}}</div>
        </div>

        <button [ngClass]="{'veeam': this.theme === 'veeam'}" class="login-button" type="submit" style="margin-top: 3rem;">
          <span>{{'__LOGIN_LOG_IN__' | translate}}</span>
          <img class="desktop-only" src="assets/icon/arrow-right.svg">
        </button>

        <div class="can-not-sign-in-text" *ngIf="isOktaEnabled" (click)="oktaLogin()">{{'Sign-In with Okta' | translate}}</div>

        <!--            <div class="can-not-sign-in-text" *ngIf="platform === 'website'" [routerLink]="['/login/sso']">Login with Microsoft</div>-->
        <!--            <div class="can-not-sign-in-text" *ngIf="platform === 'mobile'" (click)="onMicrosoftLoginMobile()">Login with Microsoft App</div>-->
        <!--            <img class="mobile-only img-bottom-mobile" src="assets/icon/mobile-bottom.svg">-->
        <!-- <div class="mobile-only powered-by" >Powered by <strong>Alchemist</strong></div> -->
        <!-- <img *ngIf="this.theme !== 'veeam'" class="desktop-only img-bottom-desktop" src="assets/icon/my721-logo.svg"> -->
      </div>
    </form>

    <div class="right-container">
      <div class="fit-box">
        <div class="height-shrinked">
          <img *ngIf="isPageReady" [ngClass]="{'veeam': this.theme === 'veeam'}" class="alchemist desktop-only" src="assets/icon/alchemist-logo.svg">
        </div>
        <div class="message">
          <div>{{ "__LOGIN_VEEAM_EMPLOYEE_MESSAGE__" | translate }}</div>
          <div>{{ "__LOGIN_PLEASE_EMAIL__" | translate }} <a href="mailto:support@thisisalchemist.com">support@thisisalchemist.com</a></div>
        </div>
        <div [ngClass]="{'veeam': this.theme === 'veeam'}" class="login-button" (click)="toLink('/login/sso')">
          <img src="assets/img/windows-icon.svg">
          <span>{{ "__LOGIN_SIGN_IN_WITH_MICROSOFT__" | translate }}</span>
          <img class="desktop-only" src="assets/icon/arrow-right.svg">
        </div>
        <div class="can-not-sign-in-text" (click)="forgotPassword()">{{'__LOGIN_CANT_SIGN_IN__' | translate}}</div>
      </div>
    </div>

    <div class="bottom-container">
      <img *ngIf="isPageReady" [ngClass]="{'veeam': this.theme === 'veeam'}" class="alchemist" src="assets/icon/alchemist-logo.svg">
    </div>
  </div>
</ion-content>
